import { useCallback } from "react";
import useAxios from '@Apis/useAxios';
import {
    GET_CHART_ADV_FILTER_OPTIONS_API,
    POST_CHART_ADV_FILTER_TAGGED_API,
    POST_CHART_ADV_FILTER_STATISTICS_API,
} from '@Apis/apiPath';

const useChartAdvancedFilterApi = () => {
    const Axios = useAxios();

    const getChartAdvFilterOptionsApi = useCallback(
        async (params = {}) => {
            const resp = await Axios.get(GET_CHART_ADV_FILTER_OPTIONS_API, params);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const postChartAdvFilterTaggedApi = useCallback(
        async (params) => {
            const resp = await Axios.post(POST_CHART_ADV_FILTER_TAGGED_API, params);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const postChartAdvFilterStatisticsApi = useCallback(
        async (params) => {
            const resp = await Axios.post(POST_CHART_ADV_FILTER_STATISTICS_API, params);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    return {
        getChartAdvFilterOptionsApi,
        postChartAdvFilterTaggedApi,
        postChartAdvFilterStatisticsApi,
    };
}

export default useChartAdvancedFilterApi;